import { render, staticRenderFns } from "./MusicTuneForm.vue?vue&type=template&id=81d110d4"
import script from "./MusicTuneForm.vue?vue&type=script&lang=js"
export * from "./MusicTuneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports